module.exports = "https://trybtryb-legacy.web.app/img/amazon_books.97ffe4ae.svg";